import { InteractionVideoLoader } from "./scene/interaction/resources";
export class Context {
    constructor() {
        this.interactionVideoLoader = new InteractionVideoLoader();
        this.config = {
            loadVideo360: "html5video",
        };
    }
}
//# sourceMappingURL=context.js.map